import _ from 'lodash'
import React, { PureComponent } from 'react'
import styled, { css } from 'styled-components'

import * as colors from '../theme/colors'
import mapMarginPaddingProps from '../theme/mapMarginPaddingProps'

import Flex from './Flex'
import Block from './Block'
import Text from './Text'

export { Flex, FlexChild, Fill } from './Flex'
export Block from './Block'
export { Text, TextBlock } from './Text'
export Title from './Title'
export Paragraph from './Paragraph'
export Divider from './Divider'
export Logotype from './Logotype'
export Link from './Link'

import mapProps from '../theme/mapProps'
import helloColor from 'hello-color'

export const ViewportRow = styled(Block).attrs({ px: 'viewport' })`
  max-width: 100vw;
  min-width: 100vw;

  ${mapProps({
    color: (color, k, { background }) => css`
      background-color: ${background || helloColor(color).color};
      color: ${color};`,
    background: {
      offwhite: css`
        background-color: ${colors.offwhite};`,
      default: (background, k, { color }) => css`
        background-color: ${background};
        color: ${color || helloColor(background).color};`,
    },
  })};
`

export const ContentRow = styled(({ children, ...props }) => (
  <ViewportRow background="offwhite" py="4" {...props}>
    <Block my="1" />
    <Container>{children}</Container>
    <Block my="1" />
  </ViewportRow>
))``

export const ViewportContent = styled(ContentRow)`
  min-height: calc(100vh - 6rem);
`

export const Headline = styled.h1`
  font-size: 3rem;
  ${mapProps({
    scale: scale => css`
      font-size: ${scale}rem;`,
  })};
`

export const Container = styled(Block)`
  width: 100%;
  max-width: 58rem;
  margin-left: auto;
  margin-right: auto;
`
export const PageContainer = styled(Container)`
  overflow: hidden;
  background-color: ${colors.white};
`

export const ViewportContainer = styled.div`
  min-height: 100%;
  font-size: 1rem;

  position: relative;
  overflow: hidden;

  ${'' /* background-color: ${colors.offwhite};
    background-color: $color(viewport.backgroundColor); */} ${'' /* transition: background-color $theme.motion.easing.slowest.easing ${({ theme }) => 2 * theme.motion.easing.duration}ms;
    will-change: background-color; */} ${'' /* @media ${media.tablet.gt} {
        padding: ${rem(0.5)};
    } */} ${'' /* ${mapProps({
        seamless: css`
            @media ${media.tablet.gt} {
                padding: 0;
            };
        `,
    })}; */} ${mapMarginPaddingProps};
`

export const Page = styled.div`
  max-width: 40rem;
  margin: 0 auto;
`

export const ViewportRibbon = props => (
  <Flex column align="center">
    <svg width="2048" height="260" viewBox="0 0 1024 130">
      <polygon fill="hsla(0, 0%, 0%, 0.05)" fillRule="evenodd" points="0 130 1034 0 1034 694 0 824" />
    </svg>
    <Flex column align="center">
      <Block px={3}>
        <Flex row="wrap" justify="around" mb="3">
          <Flex column align="center" px="1" mb="2">
            <div style={{ width: 2048, height: 260, transform: 'rotateZ(180deg)' }}>
              <svg width="2048" height="260" viewBox="0 0 1024 130">
                <polygon
                  fill="hsla(0, 0%, 0%, 0.05)"
                  fillRule="evenodd"
                  points="0 130 1034 0 1034 694 0 824"
                />
              </svg>
            </div>
          </Flex>
        </Flex>
      </Block>
    </Flex>
  </Flex>
)



// WEBPACK FOOTER //
// ./src/styleguide/index.js